import { useEffect, useState } from 'react'
import { LatLng } from '../types/geofence.type'

export const useCircle = (
    initialCenter?: LatLng,
    defaultRadius?: number | string
) => {
    const [center, setCenter] = useState<LatLng | undefined>(initialCenter)
    const [radius, setRadius] = useState<number>(
        parseInt(defaultRadius as string) ?? 0
    )
    useEffect(() => {
        setRadius(parseInt(defaultRadius as string) ?? radius)
    }, [defaultRadius])
    return {
        center,
        setCenter,
        radius,
        setRadius,
    }
}
